import { createRoute } from '@/utils/routing'

export const NOTIFICATION_CREATE_ROUTE = 'notifications'

export function createNotificationCreateRoute (options = {}) {
  return createRoute(NOTIFICATION_CREATE_ROUTE, options)
}
